import React from 'react';
import { FaTimes, FaExclamationTriangle, FaCheckCircle, FaInfoCircle, FaQuestionCircle } from 'react-icons/fa';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  type = 'info', // 'info', 'success', 'warning', 'danger', 'question'
  showCloseButton = true,
  size = 'md' // 'sm', 'md', 'lg', 'xl'
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="text-green-400 text-xl" />;
      case 'warning':
        return <FaExclamationTriangle className="text-yellow-400 text-xl" />;
      case 'danger':
        return <FaExclamationTriangle className="text-red-400 text-xl" />;
      case 'question':
        return <FaQuestionCircle className="text-blue-400 text-xl" />;
      default:
        return <FaInfoCircle className="text-blue-400 text-xl" />;
    }
  };

  const getIconBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-900/20 border-green-700';
      case 'warning':
        return 'bg-yellow-900/20 border-yellow-700';
      case 'danger':
        return 'bg-red-900/20 border-red-700';
      case 'question':
        return 'bg-blue-900/20 border-blue-700';
      default:
        return 'bg-blue-900/20 border-blue-700';
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'max-w-md';
      case 'lg':
        return 'max-w-2xl';
      case 'xl':
        return 'max-w-4xl';
      default:
        return 'max-w-lg';
    }
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className={`relative w-full ${getSizeClasses()} transform overflow-hidden rounded-lg bg-gray-800 border border-gray-700 shadow-xl transition-all`}>
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-700">
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg border ${getIconBgColor()}`}>
                {getIcon()}
              </div>
              <h3 className="text-lg font-medium text-white">
                {title}
              </h3>
            </div>
            {showCloseButton && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-white transition-colors duration-200"
              >
                <FaTimes className="text-xl" />
              </button>
            )}
          </div>

          {/* Content */}
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal; 